import { Grid, TextField } from '@material-ui/core';
import { IMyLinkTalentInfo } from 'pages/MyLinks/types';
import { memo } from 'react';
import { IProfileLink } from 'shared/interfaces/IProfile';
import { profileListLinkSetter } from 'shared/utils/profileListLinkSetter';
import CopyAndShare from 'pages/MyLinks/PublicProfileLinks/CopyAndShare/CopyAndShare';

const ProfileListLink = ({ talentInfo, profileLink }: { talentInfo: IMyLinkTalentInfo; profileLink: IProfileLink }) => {
  const urlLink = profileListLinkSetter(profileLink, talentInfo);

  return (
    <Grid container spacing={1} alignItems="center">
      <Grid item xs={12} lg={10}>
        <TextField variant="outlined" value={urlLink} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} lg={2}>
        <CopyAndShare textToCopy={urlLink} />
      </Grid>
    </Grid>
  );
};

export default memo(ProfileListLink);
